import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PatchOps from '@leverege/api-patch-ops'
import { ScriptFactory } from '~/editors/script'
import { ScriptActions, BreadcrumbActions } from '~/actions';

import style from './style.css';

class ScriptInfoScreen extends React.Component {

  componentDidMount() {
    this.props.dispatch( ScriptActions.get( this.props.match.params.projectId, this.props.match.params.scriptId ) );
  }

  componentWillReceiveProps( next ) {
    const { scripts } = next
    const { params } = this.props.match
    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]
    if ( script ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Scripts', link : `/project/${script.projectId}/script` }, 
          { name : script.name } ] ) )
    }
  
  }
  
  onScriptChange = ( { target, path, value } ) => {
    const { params } = this.props.match
    const patchOps = PatchOps().replace( path, value ).ops()
    this.props.dispatch( ScriptActions.update( params.projectId, target, patchOps ) )
  }

  render() {
    const { scripts } = this.props
    const { params } = this.props.match
    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]
    if ( script == null ) {
      return null
    }

    const details = ScriptFactory.createInfoEditor( script, {
      onChange : this.onScriptChange
    } )
    return <div className={style.pad}>{details}</div>
  }
}

export default connect(
  state => ( {
    scripts : state.scripts
  } )
)( ScriptInfoScreen );
